import { Box, Grid, Typography } from '@mui/material';
import { COLORS } from '../theme';

export const Footer = () => {
  return (
    <Grid container justifyContent="space-between" py={6} sx={{ marginTop: 'auto' }}>
      <Grid item xs={12} md={6} />
      <Grid item xs={12} md={6}>
        <Typography variant="body1" color="GrayText" sx={{ textAlign: 'right', mr: 10 }}>
          &copy; {new Date().getFullYear()}{' '}
          <Box component="span" sx={{ color: COLORS.PRIMARY }}>
            Bumblebee
          </Box>
        </Typography>
      </Grid>
    </Grid>
  );
};
